// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__tv7GA","selected":"Chip_selected__1C6TR"};